import { z } from 'zod';

import { Member } from '../../types/Member';
import { ADDITIONAL_ORDERS_QA_LABELS } from '../constants/orders';
import {
  Capabilities,
  integrationNotificationCapabilityRecipientEnum,
  BookingConfirmationCapability,
} from '../../schemas/CapabilitiesSchema';
import { Order } from '../../types/Order';

export function getOrderDiscount(discount) {
  if (!discount) return 'No';
  return `${discount.title} | -$${discount.amount}`;
}

export function getOrderQaAnswers(order, tag) {
  const { qa } = order;
  if (!qa) return '';
  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
  // @ts-ignore
  return qa[ADDITIONAL_ORDERS_QA_LABELS.get(tag)] || '';
}

export function sortBach(members: Member[]): Member[] {
  return [...members].sort(a => {
    if (a.memberRole.toLowerCase() === 'bach') {
      return -1;
    }
    return 0;
  });
}

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-unused-modules
export function getFareHarborDeepLink(booking) {
  const companyName = booking.company.shortname;
  const contact = booking.pk;
  const bookingId = booking.uuid;
  return `https://demo.fareharbor.com/bach/dashboard/bookings/network/${companyName}/contacts/${contact}/bookings/${bookingId}/`;
}

export function getQuantity(
  numOfAttendees: number,
  pricingModel?: string,
  subType?: string
): number {
  const isPerPerson = pricingModel !== 'party';
  const isPerPartyAddon = !isPerPerson && subType === 'addon';
  let quantity = isPerPerson ? 0 : 1;
  if (isPerPerson) quantity = numOfAttendees;
  if (isPerPartyAddon) quantity = numOfAttendees || 1;

  return quantity;
}

const DEFAULT_BOOKING_CONFIRMATION_CAPABILITY: BookingConfirmationCapability = {
  channel: 'manual',
};

export const getBookingConfirmationSettings = (capabilities?: Capabilities) =>
  capabilities?.bookingConfirmation || DEFAULT_BOOKING_CONFIRMATION_CAPABILITY;

export const getBookingConfirmationRecipient = (
  capability: BookingConfirmationCapability
): z.infer<typeof integrationNotificationCapabilityRecipientEnum> | undefined =>
  capability.channel === 'integration' ? capability.recipient : undefined;

export const isOrderCancelled = (order?: Order | null) =>
  order?.status === 'Cancelled';
export const isOrderFulfilled = (order?: Order | null) =>
  order?.status === 'Fulfilled';
export const isOrderPending = (order?: Order | null) =>
  order?.status === 'Pending';
export const allowedToCancelOrder = (order?: Order | null) =>
  ['Pending', 'PaymentFailure', 'Fulfilled'].includes(order?.status || '');
export const allowedToFulfillOrder = (order?: Order | null) =>
  ['Pending', 'PaymentFailure'].includes(order?.status || '');
